import { Component, OnDestroy, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { TablerIconComponent } from '@ukam/ui-kit/icon/tabler-icon.component';
import { MaterialModule } from '@ukam/ui-kit/material.module';
import { AppStatusBadgeComponent } from '@ukam/ui-kit/status-badge/status-badge.component';
import { formatBytes } from '@ukam/core/functions/bytes.functions';
import { StoredFileFinderService } from '../services/stored-file-finder.service';

@Component({
  selector: 'app-stored-file-finder-register',
  templateUrl: './register.component.html',
  imports: [
    MaterialModule,
    TablerIconComponent,
    NgScrollbarModule,
    TranslocoModule,
    RouterModule,
    DatePipe,
    AppStatusBadgeComponent,
  ],
})
export class AppStoredFileFinderRegisterComponent implements OnDestroy {
  service = inject(StoredFileFinderService);

  private router = inject(Router);
  private route = inject(ActivatedRoute);

  formatBytes = formatBytes;

  constructor() {
    this.route.paramMap.pipe(takeUntilDestroyed()).subscribe(params => {
      const id = params.get('id');
      if (id) this.service.getById(id);
    });
  }

  close(): void {
    this.service.clear();
    this.router.navigate(['../'], { relativeTo: this.route });
  }

  ngOnDestroy(): void {
    this.service.clear();
  }
}
